(function () {
  // Keep in sync with the live discount tiers created by src/shopify/createTieredDiscounts.js.
  // This is a display-only preview — Shopify's checkout is the source of truth for the actual discount.
  var TIER_THRESHOLDS = [1, 2, 3];
  var TIER_DISCOUNTS = [
    { min: 3, pct: 0.25 },
    { min: 2, pct: 0.15 },
    { min: 0, pct: 0 }
  ];

  function getDiscountPct(qty) {
    for (var i = 0; i < TIER_DISCOUNTS.length; i++) {
      if (qty >= TIER_DISCOUNTS[i].min) return TIER_DISCOUNTS[i].pct;
    }
    return 0;
  }

  function getTierSummary(qty) {
    if (qty >= 3) return '25% off unlocked!';
    if (qty === 2) return 'Add 1 more item for 25% off your order';
    if (qty === 1) return 'Add 1 more item for 15% off your order';
    return 'Add 2 items for 15% off your order';
  }

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-mix-match]');
    if (!root) return;

    var selections = {}; // variantId -> { qty, price, title }
    var itemSetters = {}; // variantId -> setQty function, so the selected-items list can remove a line
    var panel = document.querySelector('[data-mix-match-panel]');
    var toggleBtn = document.querySelector('[data-mix-match-toggle]');
    var closeBtn = document.querySelector('[data-mix-match-close]');
    var backdrop = document.querySelector('[data-mix-match-backdrop]');
    var countEl = document.querySelector('[data-mix-match-count]');
    var countBadgeEl = document.querySelector('[data-mix-match-count-badge]');
    var subtotalEl = document.querySelector('[data-mix-match-subtotal]');
    var subtotalOriginalEl = document.querySelector('[data-mix-match-subtotal-original]');
    var savingsEl = document.querySelector('[data-mix-match-savings]');
    var selectedListEl = document.querySelector('[data-mix-match-selected-list]');
    var tierSummaryEl = document.querySelector('[data-mix-match-tier-summary]');
    var tierEls = document.querySelectorAll('[data-mix-match-tier]');
    var addToCartBtn = document.querySelector('[data-mix-match-add-to-cart]');

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function openPanel() {
      panel.classList.add('is-open');
      backdrop.classList.add('is-open');
      toggleBtn.hidden = true;
    }

    function closePanel() {
      panel.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      toggleBtn.hidden = false;
    }

    toggleBtn.addEventListener('click', openPanel);
    closeBtn.addEventListener('click', closePanel);
    backdrop.addEventListener('click', closePanel);

    function updatePanel() {
      var totalQty = 0;
      var subtotal = 0;
      Object.keys(selections).forEach(function (id) {
        totalQty += selections[id].qty;
        subtotal += selections[id].qty * selections[id].price;
      });

      countEl.textContent = totalQty;
      countBadgeEl.textContent = totalQty;
      addToCartBtn.disabled = totalQty === 0;

      var pct = getDiscountPct(totalQty);
      var discountedSubtotal = Math.round(subtotal * (1 - pct));
      var savings = subtotal - discountedSubtotal;
      subtotalEl.textContent = formatMoney(discountedSubtotal);
      if (pct > 0) {
        subtotalOriginalEl.textContent = formatMoney(subtotal);
        subtotalOriginalEl.hidden = false;
        savingsEl.textContent = 'You\'re saving ' + formatMoney(savings) + '!';
        savingsEl.hidden = false;
      } else {
        subtotalOriginalEl.hidden = true;
        savingsEl.hidden = true;
      }

      selectedListEl.innerHTML = '';
      Object.keys(selections).forEach(function (id) {
        var sel = selections[id];
        var li = document.createElement('li');
        li.className = 'mix-match-panel__selected-item';

        var label = document.createElement('span');
        label.textContent = sel.qty + '× ' + sel.title;

        var lineTotal = document.createElement('span');
        lineTotal.className = 'mix-match-panel__selected-item-price';
        lineTotal.textContent = formatMoney(sel.qty * sel.price);

        var removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'mix-match-panel__selected-item-remove';
        removeBtn.setAttribute('aria-label', 'Remove ' + sel.title);
        removeBtn.textContent = '×';
        removeBtn.addEventListener('click', function () {
          if (itemSetters[id]) itemSetters[id](0);
        });

        li.appendChild(label);
        li.appendChild(lineTotal);
        li.appendChild(removeBtn);
        selectedListEl.appendChild(li);
      });

      tierEls.forEach(function (el) {
        var threshold = parseInt(el.getAttribute('data-mix-match-tier'), 10);
        el.classList.toggle('is-unlocked', totalQty >= threshold);
      });
      tierSummaryEl.textContent = getTierSummary(totalQty);

      if (totalQty > 0 && window.innerWidth < 768) {
        openPanel();
      }
    }

    root.querySelectorAll('[data-mix-match-item]').forEach(function (item) {
      var variantId = item.getAttribute('data-variant-id');
      var price = parseInt(item.getAttribute('data-price'), 10);
      var title = item.getAttribute('data-title');
      var qtyEl = item.querySelector('[data-mix-match-qty]');

      function setQty(qty) {
        qty = Math.max(0, qty);
        qtyEl.textContent = qty;
        if (qty === 0) {
          delete selections[variantId];
        } else {
          selections[variantId] = { qty: qty, price: price, title: title };
        }
        updatePanel();
      }

      itemSetters[variantId] = setQty;

      item.querySelector('[data-mix-match-increment]').addEventListener('click', function () {
        setQty((selections[variantId] ? selections[variantId].qty : 0) + 1);
      });
      item.querySelector('[data-mix-match-decrement]').addEventListener('click', function () {
        setQty((selections[variantId] ? selections[variantId].qty : 0) - 1);
      });
    });

    updatePanel();

    addToCartBtn.addEventListener('click', function () {
      var items = Object.keys(selections).map(function (id) {
        return { id: id, quantity: selections[id].qty };
      });
      if (items.length === 0) return;

      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'Adding...';

      var routes = (window.theme && window.theme.routes) || {};
      var cartAddUrl = routes.cart_add_url || '/cart/add.js';
      var cartUrl = routes.cart || '/cart';

      fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (data) { throw new Error(data.description || 'Add to cart failed'); });
          return res.json();
        })
        .then(function () {
          window.location.href = cartUrl;
        })
        .catch(function (err) {
          console.error(err);
          alert('Something went wrong adding items to your cart. Please try again.');
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = 'Add to Cart';
        });
    });
  });
})();
